import ContractTypeBaseController from "../common/contract_type.base.controller";

class ContractTypeEditController extends ContractTypeBaseController {
    /*@ngInject*/
    constructor(Auth, User, $state, $translate, $stateParams, $location, Modal, ContractTypeService, $q) {

        super(Auth, $state, User, ContractTypeService, Modal, $translate, $stateParams)

        this.Auth = Auth;
        this.User = User;
        this.$state = $state;
        this.$translate = $translate;
        this.$stateParams = $stateParams;
        this.$location = $location;
        this.Modal = Modal;
        this.ContractTypeService = ContractTypeService;
        this.$q = $q;

        this.defaultModel = {
            type: null,
            description: null,
        }

        this.model = angular.copy(this.defaultModel);
    }

    $onInit() {
        this.loading = true;
        this.Service.get(this.$stateParams.id)
            .then((data) => {
                this.defaultModel = data;
                this.rawId = data.id;
                this.model.id = data.id;
                this.model.type = data.type;
                this.model.description = data.description;
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                this.loading = false;
            })
    }

    reset() {
        this.model = angular.copy(this.defaultModel);
    }

    update() {
        this.model.isUpdating = true;
        delete this.model.errorMessage;

        this.Service.update(this.$stateParams.id, {
            type: this.model.type,
            description: this.model.description,
        })
            .then(() => {
                window.history.go(-1);
            })
            .catch((err) => {
                err.data.errors.map((e) => {
                    this.model.errorMessage = e.message;
                })
            })
            .finally(() => {
                this.model.isUpdating = false;
            })
    }
}

export default ContractTypeEditController;



// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/contract_type/edit/contract_type.edit.controller.js